var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowRight = function SvgKeyboardDoubleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "keyboard_double_arrow_right_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keyboard_double_arrow_right_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.575 12 5.7 8.1a.98.98 0 0 1-.288-.687A.93.93 0 0 1 5.7 6.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l4.6 4.6q.15.15.213.325.062.175.062.375t-.062.375a.9.9 0 0 1-.213.325l-4.6 4.6a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.425.275-.7zm6.6 0L12.3 8.1a.98.98 0 0 1-.288-.687.93.93 0 0 1 .288-.713.95.95 0 0 1 .7-.275q.425 0 .7.275l4.6 4.6q.15.15.212.325.063.175.063.375t-.062.375a.9.9 0 0 1-.213.325l-4.6 4.6a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.425.275-.7z"
  }))));
};
export default SvgKeyboardDoubleArrowRight;